const reviews = [
    {
        label: 'K C Lakshmanan',
        description: 'From the very beginning, the team was professional, organized, and easy to communicate with. They kept me in the loop throughout the entire project and delivered my home exactly as promised — on time and beyond expectations. I highly recommend them!',
        rating: 4
    },
    {
        label: 'N Vinoth',
        description: 'I was blown away by the attention to detail in every part of my home. The craftsmanship is simply top-notch. It’s clear they take pride in their work, and it really shows. I couldn’t be happier with how everything turned out.',
        rating: 5
    },
    {
        label: 'R Balasundaram',
        description: 'I had heard horror stories about building a home, but this team made the experience so smooth and stress-free. They were honest, transparent, and genuinely cared about getting everything right. I felt supported every step of the way.',
        rating: 3
    },
    {
        label: 'N Xavier',
        description: 'What stood out to me most was how clearly and consistently they communicated. I always knew what was happening, and the project was even finished ahead of schedule — without cutting any corners. That kind of reliability is hard to find!',
        rating: 5
    },
];

export default reviews;
